import { post, patch, get, deletee } from "./index";

export const getBanners = (params) => {
  const request = {
    subUrl: `/website/getAllBanners/`,
    params
  };
  return get(request);
};
